document.addEventListener('DOMContentLoaded', () => {
  const viewport = document.querySelector('.rack-viewport');
  const track = document.querySelector('.rack-track');
  const items = [...document.querySelectorAll('.rack-item')];

  if (!viewport || !track || !items.length) return;

  const isTouch = window.matchMedia('(pointer: coarse)').matches;

  const floatingTag = document.querySelector('.rack-floating-tag');
  const tagName = floatingTag?.querySelector('.rack-tag-name');
  const tagMeta = floatingTag?.querySelector('.rack-tag-meta');
  const tagPrice = floatingTag?.querySelector('.rack-tag-price');

  const nameEl = document.getElementById('product-name');
  const formEl = document.getElementById('product-form');
  const sizeEl = document.getElementById('product-size');
  const priceEl = document.getElementById('product-price');

  function updateDetails(activeItem) {
    if (!activeItem) return;

    if (nameEl) nameEl.textContent = activeItem.dataset.name || '';
    if (formEl) formEl.textContent = activeItem.dataset.form || '';
    if (sizeEl) sizeEl.textContent = activeItem.dataset.size || '';
    if (priceEl) priceEl.textContent = activeItem.dataset.price || '';
  }

  function updateFloatingTag(activeItem) {
    if (!activeItem || !floatingTag) return;

    floatingTag.classList.add('is-visible');

    if (isTouch) {
      floatingTag.style.left = '50%';
    } else {
      const viewportRect = viewport.getBoundingClientRect();
      const activeMover = activeItem.querySelector('.rack-item-inner');
      const activeRect = activeMover
        ? activeMover.getBoundingClientRect()
        : activeItem.getBoundingClientRect();

      const activeCenterX =
        activeRect.left - viewportRect.left + activeRect.width / 2;

      floatingTag.style.left = `${activeCenterX}px`;
    }

    if (tagName) tagName.textContent = activeItem.dataset.name || '';

    if (tagMeta) {
      tagMeta.textContent = [
        activeItem.dataset.form,
        activeItem.dataset.size
      ].filter(Boolean).join(' · ');
    }

    if (tagPrice) tagPrice.textContent = activeItem.dataset.price || '';
  }

  function resetRack() {
    if (floatingTag) floatingTag.classList.remove('is-visible');

    items.forEach(item => {
      item.classList.remove('is-selected');

      const mover = item.querySelector('.rack-item-inner');
      const bottle = item.querySelector('.rack-bottle');

      if (mover) mover.style.transform = 'translateX(0px)';
      if (bottle) bottle.style.transform = 'scale(1)';
    });
  }


    function initMobileRack() {
        const bottleWidth = 60; 
        const bottleNumber = 24;
        const bottleRowWidth = bottleWidth * bottleNumber;
        const screenWidth = window.innerWidth;
        
        const bottleRowToScroll = document.querySelector('.rack-viewport');

        const MIN_SCROLL = screenWidth;
        const MAX_SCROLL = bottleRowToScroll.scrollWidth - bottleRowToScroll.clientWidth - screenWidth;

        const bottles = [...document.querySelectorAll('.rack-item')];

        const floatingTag = document.querySelector('.rack-floating-tag');
        const tagName = floatingTag?.querySelector('.rack-tag-name');
        const tagMeta = floatingTag?.querySelector('.rack-tag-meta');
        const tagPrice = floatingTag?.querySelector('.rack-tag-price');

        let clampEnabled = true;
        let isAutoScrolling = false;

        let scrollTimeout;

        window.addEventListener('scroll', () => {
            clearTimeout(scrollTimeout);

            scrollTimeout = setTimeout(() => {
                resetBottleScale();
            }, 100);
        });

        function showBottleTag(index) {
            const bottle = bottles[index];
            if (!bottle || !floatingTag) return;

            floatingTag.classList.add('is-visible');
            floatingTag.style.left = '50%';

            if (tagName) {
                tagName.textContent = bottle.dataset.name || '';
            }

            if (tagMeta) {
                tagMeta.textContent = [
                    bottle.dataset.form,
                    bottle.dataset.size
                ].filter(Boolean).join(' · ');
            }

            if (tagPrice) {
                tagPrice.textContent = bottle.dataset.price || '';
            }
        }

        function resetBottleScale() {
            bottles.forEach(bottle => {
                bottle.classList.remove('active', 'neighbor');
            });
            if (floatingTag) {
                floatingTag.classList.remove('is-visible');
            }
        }

        function scaleBottle(index) {
            bottles.forEach((bottle, i) => {
                bottle.classList.remove('active', 'neighbor');

                if (i === index)
                    bottle.classList.add('active');
                else if (Math.abs(i - index) === 1)
                    bottle.classList.add('neighbor');
            });
        }

        bottleRowToScroll.addEventListener('scroll', () => {
            const x = bottleRowToScroll.scrollLeft;
            if (!isAutoScrolling) {
                resetBottleScale();
            }

            if (!clampEnabled) {
                if (x >= MIN_SCROLL && x <= MAX_SCROLL) {
                    clampEnabled = true;
                }
                return;
            }

            if (x < MIN_SCROLL) {
                bottleRowToScroll.scrollLeft = MIN_SCROLL;
            }

            if (x > MAX_SCROLL) {
                bottleRowToScroll.scrollLeft = MAX_SCROLL;
            }
        }, { passive: true });

        function bottleScroll(index) {
            const scrollToX_leftOfScreen = (index * bottleWidth) + screenWidth;
            const scrollToX_centerOfBottle = scrollToX_leftOfScreen + (bottleWidth / 2);
            const scrollToX_centerOfScreen = scrollToX_centerOfBottle - (screenWidth / 2); 

            let activeScrollOffset = 15; // active item grows 30px, center moves 15px

            if (index > 0) {
                activeScrollOffset += 15; // left neighbor grew 15px before active bottle
            }

            const scrollToX = scrollToX_centerOfScreen + activeScrollOffset;

            clampEnabled = false;
            isAutoScrolling = true;

            bottleRowToScroll.scrollTo({
                left: scrollToX,
                top: 0,
                behavior: 'smooth'
            });

            window.setTimeout(() => {
                isAutoScrolling = false;
            }, 600);
        }

        let pointerStartX = 0;
        let pointerStartY = 0;
        let pointerStartIndex = null;

        bottles.forEach((bottle, index) => {
            bottle.addEventListener('pointerdown', e => {
                pointerStartX = e.clientX;
                pointerStartY = e.clientY;
                pointerStartIndex = index;
            });

            bottle.addEventListener('pointerup', e => {
                const movedX = Math.abs(e.clientX - pointerStartX);
                const movedY = Math.abs(e.clientY - pointerStartY);

                const TAP_THRESHOLD = 10;

                if (movedX > TAP_THRESHOLD || movedY > TAP_THRESHOLD) {
                    resetBottleScale();
                    return; // it was a drag, not a tap
                }

                if (pointerStartIndex !== index) {
                    return;
                }

                bottleScroll(index);
                showBottleTag(index);
                scaleBottle(index);
            });
        });

        bottleRowToScroll.scrollLeft = screenWidth;
    }

  function initDesktopRack() {
    const MIN_SCALE = 1;
    const MAX_SCALE = 1.55;
    const EFFECT_RADIUS = 180;
    const PUSH_AMOUNT = 22;
    const SNAP_RADIUS = 10;

    const EDGE_ZONE = 180;
    const MAX_SCROLL_SPEED = 14;

    let mouseX = null;
    let isHovering = false;
    let animationFrame = null;

    function updateRack() {
      animationFrame = null;

      const viewportRect = viewport.getBoundingClientRect();

      if (mouseX === null) {
        resetRack();
        return;
      }

      let activeIndex = 0;
      let closestDistance = Infinity;

      const scales = [];
      const influences = [];

      items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const itemCenterX = rect.left + rect.width / 2;
        const distance = Math.abs(mouseX - itemCenterX);

        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      const activeRect = items[activeIndex].getBoundingClientRect();
      const activeCenterX = activeRect.left + activeRect.width / 2;

      let effectX = mouseX;

      if (Math.abs(mouseX - activeCenterX) <= SNAP_RADIUS) {
        effectX = activeCenterX;
      }

      items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const itemCenterX = rect.left + rect.width / 2;
        const distance = Math.abs(effectX - itemCenterX);

        let influence;

        if (distance <= SNAP_RADIUS) {
          influence = 1;
        } else {
          influence = Math.max(
            0,
            1 - (distance - SNAP_RADIUS) / (EFFECT_RADIUS - SNAP_RADIUS)
          );
        }

        const scale = MIN_SCALE + influence * (MAX_SCALE - MIN_SCALE);

        influences[index] = influence;
        scales[index] = scale;
      });

      items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const itemCenterX = rect.left + rect.width / 2;

        let push = 0;

        influences.forEach((influence, otherIndex) => {
          if (otherIndex === index) return;

          const otherItem = items[otherIndex];
          const otherRect = otherItem.getBoundingClientRect();
          const otherCenterX = otherRect.left + otherRect.width / 2;

          if (itemCenterX < otherCenterX) {
            push -= influence * PUSH_AMOUNT;
          } else {
            push += influence * PUSH_AMOUNT;
          }
        });

        const mover = item.querySelector('.rack-item-inner');
        const bottle = item.querySelector('.rack-bottle');

        if (mover) mover.style.transform = `translateX(${push}px)`;
        if (bottle) bottle.style.transform = `scale(${scales[index]})`;
      });

      items.forEach(item => item.classList.remove('is-selected'));

      const activeItem = items[activeIndex];

      if (activeItem) {
        activeItem.classList.add('is-selected');
        updateDetails(activeItem);
        updateFloatingTag(activeItem);
      }

      if (isHovering) {
        const leftDistance = mouseX - viewportRect.left;
        const rightDistance = viewportRect.right - mouseX;

        let scrollSpeed = 0;

        if (leftDistance < EDGE_ZONE) {
          scrollSpeed = -MAX_SCROLL_SPEED * (1 - leftDistance / EDGE_ZONE);
        } else if (rightDistance < EDGE_ZONE) {
          scrollSpeed = MAX_SCROLL_SPEED * (1 - rightDistance / EDGE_ZONE);
        }

        if (scrollSpeed !== 0) {
          viewport.scrollLeft += scrollSpeed;
          requestUpdate();
        }
      }
    }

    function requestUpdate() {
      if (!animationFrame) {
        animationFrame = requestAnimationFrame(updateRack);
      }
    }

    viewport.addEventListener('mousemove', e => {
      mouseX = e.clientX;
      isHovering = true;
      requestUpdate();
    });

    viewport.addEventListener('mouseenter', e => {
      mouseX = e.clientX;
      isHovering = true;
      requestUpdate();
    });

    viewport.addEventListener('mouseleave', e => {
      if (floatingTag && floatingTag.contains(e.relatedTarget)) return;

      mouseX = null;
      isHovering = false;
      resetRack();
    });

    if (floatingTag) {
      floatingTag.addEventListener('mouseenter', () => {
        isHovering = false;
      });

      floatingTag.addEventListener('mouseleave', e => {
        if (viewport.contains(e.relatedTarget)) return;

        mouseX = null;
        isHovering = false;
        resetRack();
      });
    }

    viewport.addEventListener('scroll', requestUpdate, { passive: true });
  }

  if (isTouch) {
    initMobileRack();
  } else {
    initDesktopRack();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.pz-mobile-menu-toggle');
  const menu = document.querySelector('.pz-header-menu-holder');

  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => {
    const isOpen = menu.classList.toggle('is-open');

    toggle.classList.toggle('is-open', isOpen);
    toggle.setAttribute('aria-expanded', String(isOpen));
  });
});